/* eslint-disable */
module.exports = function() {
  return function() {};
};
